import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Observable } from 'rxjs';
import { AssetAttachmentDialog } from '../../../modules/asset/components/asset-view-attachment-dialog/asset-view-attachment-dialog.component';
import { AssetAttachmentModel } from '../../../modules/asset/components/model/asset-attachment.model';
import { UIDialogService } from '../../services/ui-dialog.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-asset-attachments',
  templateUrl:
    'console/app-js/shared/components/asset-attachments/asset-attachments.component.html'
})
export class AssetAttachmentsComponent implements OnInit {
  @Input() attachments: Observable<AssetAttachmentModel>;
  @Input() tabIndex: number;
  @Output() selectedAttachments: EventEmitter<Array<string>> = new EventEmitter<
    Array<string>
  >();

  constructor(protected dialogService: UIDialogService) {}
  public attachmentUrls = new Array<string>();
  ngOnInit() {}

  parseFileExtensionFromKey = (key: string) => {
    if (!key) {
      return '';
    }
    const fileName = key;
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return extension ? extension : '';
  };

  isImageFileExtension = (extension: string) => {
    const imgExtensions = ['PNG', 'JPEG', 'GIF', 'TIFF', 'JPG', 'HEIC'];
    return imgExtensions.indexOf(extension.toUpperCase()) > -1;
  };

  onCheckBoxChange(attachmentUrl: string, event: any): void {
    if (event.target.checked == true) {
      this.attachmentUrls.push(attachmentUrl);
    } else {
      this.attachmentUrls.forEach((element, index) => {
        if (element === attachmentUrl) {
          this.attachmentUrls.splice(index, 1);
        }
      });
    }
    this.selectedAttachments.emit(this.attachmentUrls);
  }

  public viewAttachmentPhoto(
    assetAttachments: Array<AssetAttachmentModel>,
    selectedIndex: number
  ): void {
    this.dialogService
      .open(AssetAttachmentDialog, [
        { provide: Array, useValue: assetAttachments },
        { provide: Number, useValue: selectedIndex }
      ])
      .then(result => {});
  }

  public shotThumbnailOrIcon(attachmentKey: string) {
    if (
      this.isImageFileExtension(this.parseFileExtensionFromKey(attachmentKey))
    ) {
      return true;
    } else {
      return false;
    }
  }
}
